module.exports = __webpack_public_path__ + "static/media/azerbaijan.b63c1b66.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/azerbaijan.png
// module id = 42
// module chunks = 0